module.exports = __webpack_public_path__ + "img/near.0ede19eb.jpeg";